export default __webpack_public_path__ + "static/media/3. Post Visit Doctor Reflection.6c1d4738.wav";